<template>
    <div class="time">
        <span>{{initTime}}</span> <span style="margin-left: 8px">s</span>
    </div>
</template>
<script>
    export default {
      name:'time',
      props:{
        time:{
          type:Number,
          default:60
        }
      },
      data(){
        return {
          internalHandler:null,
          initTime:this.time
        }
      },
      mounted() {
        this.init()
      },
      methods:{
        init(){
          this.initTime = this.time || 60
          this.internalHandler = setInterval(this.setTime,1000)
        },
        setTime(){
          this.initTime--
          if(this.initTime ===0){
            clearInterval(this.internalHandler)
            this.$emit('over')
          }
        }
      }
    }
</script>
<style>
    .time{
        font-size: 20px;
        color: #ddd;
        cursor: not-allowed;
        display: inline-block;
        width: 80%;
        height: 100%;
        text-align: center;
    }
</style>